export default __webpack_public_path__ + "static/favicon-e9a2d3ac8f84650b4ff363e076ce5dd6.png";